import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// When the HTML was prerendered (by scripts/prerender.js), #root already has
// children and we hydrate on top of them. Otherwise (dev, or a route that
// wasn't prerendered) we render from scratch.
const rootEl = document.getElementById('root');
const tree = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (rootEl.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootEl, tree);
} else {
  ReactDOM.createRoot(rootEl).render(tree);
}

reportWebVitals();
